// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f4489b7a","248":"5b876f5c","342":"4c456475","381":"881412d1","600":"1815eb7d","655":"2febe6be","787":"396a3f3c","825":"9b07ca10","940":"797e9fa2","984":"8611f312"}[chunkId] + ".chunk.js";
};